<template>
  <div class="career-search">
    <span
      v-if="!isMobile"
      class="career-search__matches"
    >
      {{ getTotalNumOfCareers }} Open Positions
    </span>
    <div :class="{ 'content-container': isMobile }">
      <div
        class="career-search__search-bar-container"
        :class="{ 'career-search__search-bar-container--empty': !isSearchEmpty }"
      >
        <SearchIcon />
        <input
          v-model="search"
          aria-label="Search"
          id="search"
          type="text"
          class="tw-input career-search__search-bar"
          placeholder="Job Title, Keyword, etc."
          title="Search"
        >
        <img
          v-if="getSearchQuery"
          class="career-search__close-icon"
          src="/career-search/close.svg"
          @click="clearSearch"
          aria-label="Close Button"
          alt="Close Button Icon"
        />
        <button
          v-if="isMobile"
          class="btn career-search__search-btn"
          @click="toggleFilters"
          type="button"
        >
          <span class="btn__text">Filters</span>
          <span class="btn__swoop"></span>
        </button>
      </div>
    </div>
    <span
      v-if="isMobile"
      class="career-search__matches"
    >
      {{ getTotalNumOfCareers }} Open Positions
    </span>
    <div
      :class="isFiltersOpen ? 'career-search__filters--open' : !isFiltersOpen && isMobile ? 'career-search__filters--closed' : ''"
      class="career-search__filters"
    >
      <div class="career-search__wrapper">
        <span class="career-search__matches career-search__matches--mobile">
          <div class="content-container career-search__matches-container">
            <span>{{ getTotalNumOfCareers }} Open Positions</span>
            <ClearFilters :simple="true" />
          </div>
        </span>
        <FilterAccordion
          :filter-data="getLocationData"
        />
        <FilterAccordion
          :filter-data="getDepartmentData"
        />
        <FilterAccordion
          :filter-data="getTeamData"
        />
      </div>
      <button
        class="career-search__btn btn"
        @click="toggleFilters"
        type="button"
      >
        <span class="btn__text">Done</span>
        <span class="btn__swoop"></span>
      </button>
    </div>
  </div>
</template>

<script>
import ClearFilters from '@/components/subcomponents/filters/ClearFilters.vue'
import FilterAccordion from '@/components/subcomponents/filters/FilterAccordion.vue'
import SearchIcon from '@/components/subcomponents/svg/SearchIcon.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CareerSearch',
  components: {
    FilterAccordion,
    SearchIcon,
    ClearFilters
  },
  data: () => {
    return {
      isMobile: false,
      isFiltersOpen: false,
      headerNav: document.querySelector('[data-comp-navigationheader]'),
      isSearchEmpty: true
    }
  },
  computed: {
    ...mapGetters({
      getTotalNumOfCareers: 'results/getTotalNumOfCareers',
      getSearchQuery: 'filters/getSearch',
      getLocationParams: 'queryParams/getLocationParams',
      getLocations: 'filters/getLocations',
      getDepartmentParams: 'queryParams/getDepartmentParams',
      getDepartments: 'filters/getDepartments',
      getTeamParams: 'queryParams/getTeamParams',
      getTeams: 'filters/getTeams'
    }),
    getLocationData () {
      return {
        label: 'Locations',
        category: 'locationFilters',
        array: this.getLocations,
        accordionStatus: this.getLocationParams.length !== 0
      }
    },
    getDepartmentData () {
      return {
        label: 'Departments',
        category: 'departmentFilters',
        array: this.getDepartments,
        accordionStatus: this.getDepartmentParams.length !== 0
      }
    },
    getTeamData () {
      return {
        label: 'Teams',
        category: 'teamFilters',
        array: this.getTeams,
        accordionStatus: this.getTeamParams.length !== 0
      }
    },
    search: {
      set (search) {
        const searchQuery = search.toLowerCase().replace(/ /g, ' ')
        this.$store.commit('filters/setKeywordSearch', searchQuery)
      },
      get () {
        return this.getSearchQuery
      }
    }
  },
  beforeMount () {
    window.addEventListener('resize', this.resizeEventHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeEventHandler)
  },
  mounted () {
    this.resizeEventHandler()
  },
  methods: {
    resizeEventHandler () {
      requestAnimationFrame(() => {
        if (window.innerWidth >= '768') {
          this.closeFilterModal()
          this.isMobile = false
          this.isFiltersOpen = false
        } else this.isMobile = true

        this.$emit('togglePageHeader', this.isFiltersOpen)
      })
    },
    toggleFilters () {
      this.isFiltersOpen = !this.isFiltersOpen
      this.isFiltersOpen ? this.openFilterModal() : this.closeFilterModal()

      this.$emit('togglePageHeader', this.isFiltersOpen)
    },
    openFilterModal () {
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100vh'
      if (this.headerNav) this.headerNav.classList.add('header-main--closed')
    },
    closeFilterModal () {
      document.body.style.overflow = 'auto'
      document.body.style.height = 'auto'
      if (this.headerNav) this.headerNav.classList.remove('header-main--closed')
    },
    clearSearch () {
      this.$store.commit('filters/clearSearch')
    }
  }
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;
@use 'variables';

.career-search {
  margin-bottom: 1.5rem;
  margin-top: -2rem;
  position: relative;
  box-sizing: border-box;

  @include breakpoint-md {
    flex: 0 0 260px;
    margin-top: 1.25rem;
    margin-right: 2rem;
    margin-bottom: 0;
  }

  &__close-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 6rem;
    cursor: pointer;
    width: 1.25rem;
    height: 1.25rem;

    @include breakpoint-md {
      right: 1rem;
    }
  }

  &__search-bar {
    padding-left: 2.75rem;
    padding-right: 3rem;

    @include mobile-only {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
    }

    @include breakpoint-md {
      width: 100%;
    }

    &::placeholder {
      color: variables.$color-gray-3;
    }

    &:hover, &:focus {
      outline: none;
    }
  }

  &__search-bar-container {
    position: relative;
    display: flex;

    @include breakpoint-md {
      display: block;
    }
  }

  &__search-btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 100%;

    @include mobile-only {
      padding-right: 1.75rem;
    }

    .btn__swoop {
      width: 115%;
    }
  }

  &__wrapper {
    height: calc(100vh - 8.75rem);
    overflow: auto;
    padding-bottom: 10rem;

    @include breakpoint-md {
      height: auto;
      overflow: hidden;
      padding-bottom: 0;
    }
  }

  &__matches {
    background-color: variables.$color-gray-5;
    color: variables.$color-white;
    padding: 0.25rem 1rem;
    border-radius: 4px;
    text-transform: uppercase;
    display: table;
    text-align: center;
    font-size: 1em;
    font-weight: bold;
    margin: 1.5rem auto 0;

    @include breakpoint-md {
      display: block;
      margin: 0 auto 1rem;
    }

    &--mobile {
      width: 100%;
      position: relative;
      left: 0;
      margin-top: 0;
      border-radius: 0;
      text-align: unset;
      padding: 1rem 0;

      @include breakpoint-md {
        display: none;
      }
    }
  }

  &__matches-container {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__filters {
    position: absolute;
    top: -1rem;
    left: 0;
    width: 100%;
    height: 100vh;
    display: block;
    z-index: 999;
    opacity: 0;
    visibility: hidden;

    @include breakpoint-md {
      position: relative;
      top: unset;
      left: unset;
      transform: none;
      height: auto;
      opacity: 1;
      visibility: visible;
      z-index: 1;
      margin-top: 1rem;
    }

    &--open {
      background-color: variables.$color-gray-1;
      opacity: 1;
      visibility: visible;
      overflow: auto;
    }

    &--closed {
      opacity: 0;
      visibility: hidden;
    }
  }

  &__btn {
    border-radius: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    margin-bottom: 0;
    width: 100%;

    @include breakpoint-md {
      display: none;
    }
  }
}
</style>
